import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  routes: (_routes) => {
    if (useRuntimeConfig().public.client === 'flinkster') {
      for (const route of _routes) {
        if (route.path.includes('/get-the-app')) {
          route.path = '/:locale/get-the-app'
        }
      }
    } else {
      for (const route of _routes) {
        if (route.path.includes('/get-the-app')) {
          route.path = '/:locale/get-the-app'
        }
        if (route.path.includes('/cancel-contract')) {
          route.path = '/:locale/kuendigen'
        }

        if (route.path.includes('/rad-melden')) {
          route.path = '/:locale/rad-melden'
        }
        if (route.path.includes('/report-a-bike')) {
          route.path = '/:locale/report-a-bike'
        }

        if (route.path.includes('/webviews/de/melden')) {
          route.path = '/webviews/:locale/melden'
        }
        if (route.path.includes('webviews/en/report')) {
          route.path = '/webviews/:locale/report'
        }

        if (route.path.includes('/anmelden')) {
          route.path = '/:locale/anmelden'
        }
        if (route.path.includes('/login')) {
          route.path = '/:locale/login'
        }

        if (route.path.includes('/embedded-anmelden')) {
          route.path = '/:locale/embedded-anmelden'
        }
        if (route.path.includes('/embedded-login')) {
          route.path = '/:locale/embedded-login'
        }

        if (route.path.includes('/kundenbereich')) {
          route.path = '/:locale/kundenbereich'
        }
        if (route.path.includes('/self-service')) {
          route.path = '/:locale/self-service'
        }

        if (route.path.includes('/embedded-kundenbereich')) {
          route.path = '/:locale/embedded-kundenbereich'
        }
        if (route.path.includes('/embedded-self-service')) {
          route.path = '/:locale/embedded-self-service'
        }

        if (route.path.includes('/passwort-vergessen')) {
          route.path = '/:locale/passwort-vergessen'
        }
        if (route.path.includes('/forgot-password')) {
          route.path = '/:locale/forgot-password'
        }

        if (route.path.includes('/passwort-setzen')) {
          route.path = '/:locale/passwort-setzen'
        }
        if (route.path.includes('/password-reset')) {
          route.path = '/:locale/password-reset'
        }
      }
      return _routes
    }
  },
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve({
            left: savedPosition.left,
            top: savedPosition.top,
            behavior: 'smooth',
          })
        } else if (to.hash) {
          const HEADER_HEIGHT_MOBILE = 64
          const HEADER_HEIGHT_DESKTOP = 94
          const onMobile = window.matchMedia('(max-width: 600px)')
          const headerHeight = onMobile.matches
            ? HEADER_HEIGHT_MOBILE
            : HEADER_HEIGHT_DESKTOP
          if (document.getElementById('omq-help-container')) {
            const resizeObserver = new ResizeObserver((entries) => {
              const omq = entries.find(
                (entry) => entry.target.id === 'omq-help-container'
              )
              if (omq && omq.contentRect.height > 99) {
                resolve({
                  el: to.hash,
                  top: headerHeight,
                  behavior: 'smooth',
                })
              }
            })
            resizeObserver.observe(
              document.getElementById('omq-help-container')!
            )
          } else {
            resolve({
              el: to.hash,
              top: headerHeight,
              behavior: 'smooth',
            })
          }
        } else {
          resolve({ top: 0, behavior: 'smooth' })
        }
      }, 500)
    })
  },
}
